export default __webpack_public_path__ + "static/media/img-5.42ccb088.png";